<r-widget-control [control]="firstnameControl">
  <input
    nz-input
    [name]="config.name"
    [placeholder]="config.placeholder"
    [required]="config.required"
    [disabled]="config.disabled"
    [attr.id]="config.name"
    [(ngModel)]="config.value"
    ngDefaultControl
    #firstnameControl="ngModel"
  />
</r-widget-control>
